var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnakeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 290,
    viewBox: "0 0 344 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9303 281.741H299.43C378.93 281.741 305.93 262.312 299.43 260.319L203.381 229.432M43.9303 281.741H38.4303C21.9303 281.741 -5.66974 270.682 15.9303 226.443C37.5303 182.204 73.9303 187.585 89.9303 192.567L148.712 211.498M43.9303 281.741C86.9303 281.575 176.43 277.756 190.43 263.807C207.93 246.37 226.93 91.9338 220.93 70.512C249.33 74.0989 271.097 62.0429 278.43 55.5666C289.764 43.4441 294.13 16.9076 220.93 7.74108C165.43 6.24663 175.93 60.5484 174.93 70.512C174.013 79.6524 169.43 205.519 139.43 220.465C120.43 235.908 94.9303 235.908 77.4303 235.908",
    stroke: "black",
    strokeWidth: 15
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnakeIcon);
export default __webpack_public_path__ + "static/media/Snake_Icon.0197be91be5fc3e08c73a9ff6d98beb3.svg";
export { ForwardRef as ReactComponent };